module.exports = __webpack_public_path__ + "resources/img/img-solution-common-info@2x.8e961b8a.png";